<template>
    <KtvCard
        :title="$t('ktvThen.ktvPermission.title')"
    >
        <template #content>
            <DsCheckbox
                v-model="permission"
                :disabled="disabled"
                :label="$t('ktvThen.ktvPermission.label')"
                data-qa="ktv-permission-checkbox"
                required
                class="consent-checkbox"
                @input="handleInput"
            />
        </template>
    </KtvCard>
</template>

<script>
import KtvCard from './KtvCard.vue';

export default {
    components: { KtvCard },

    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            permission: false,
        };
    },

    methods: {
        handleInput(value) {
            this.permission = value;
            this.$emit('input', value);
        },
    },
};
</script>

<style scoped lang="scss">
.consent-checkbox {
    --checkbox-align-items: flex-start;
    line-height: $line-height-md;
}
</style>
